// extracted by mini-css-extract-plugin
module.exports = {"logo":"FJLogo_logo__WBxnu","c-svg-main-color":"FJLogo_c-svg-main-color__3P5XA"};